import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class GraphqlService {

  constructor(
    private http: HttpClient,
  ) {}

  private getAuthHeaders(): HttpHeaders {
    const token = JSON.parse(atob(localStorage.getItem('bWV0YURhdGFDb25maWc='))).wikiToken.token;
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }

  public query(option: { query: string }): Observable<any> {
    const headers = this.getAuthHeaders();
    const body = { query: option.query };
    const url = 'https://wiki.io-market.com/graphql/pages';

    return this.http.post<any>(url, body, { headers });
  }

  public getImage(imgUrl: string): Observable<Blob> {
    const headers = this.getAuthHeaders();
    return this.http.get(imgUrl, {
      headers,
      responseType: 'blob'
    });
  }
}
